window.bindAccessibleEmailValidation = function(inputId, errorId, message) {
    const input = document.getElementById(inputId);
    const errorElement = document.getElementById(errorId);

    if (!input || !errorElement) {
        return;
    }

    if (input.dataset.ariaValidationBound === "true") {
        return;
    }
    input.dataset.ariaValidationBound = "true";

    input.addEventListener("invalid", function() {
        this.setCustomValidity(message);
        this.setAttribute("aria-invalid", "true");
        this.setAttribute("aria-errormessage", errorId);
        errorElement.textContent = message;
    });

    input.addEventListener("input", function() {
        this.setCustomValidity("");
        this.removeAttribute("aria-invalid");
        this.removeAttribute("aria-errormessage");
        errorElement.textContent = "";
    });
};
